import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  subjectSaveMutation,
  subjectListByFilter,
} from '../../../shared/queries/Subject';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import SmartCard from '../../../shared/components/SmartCard';
import SubjectForm from './Form';

const SubjectFormHandler = (props) => {
  const { dispatch, t, history, match } = props;
  const [formOn, setFormOn] = useState(false);
  const [dto, setDto] = useState({ id: 0, active: true });

  const backClickHandler = () => {
    history.push('/minime/disciplina');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const handleSubmit = (values) => {
    showLoading();
    const mutationQuery = subjectSaveMutation(values);
    GraphQL(mutationQuery, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch((error) => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          error.response.message
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  function findById(id) {
    showLoading();
    const filter = {
      active: true,
      filterByStatus: false,
      id,
      termFilterId: 0,
      subjectLevelFilterId: 0,
      updaterId: 0,
    };
    const query = subjectListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.subjectListByFilter) {
          setDto(res.subjectListByFilter[0]);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch((error) => {
        if (error.response) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  useEffect(() => {
    setDto({ active: true, id: 0 });
  }, []);

  return (
    <SmartCard title={t('panels.disciplina')}>
      {formOn ? (
        <SubjectForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
        />
      ) : null}
    </SmartCard>
  );
};

SubjectFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(SubjectFormHandler)
);
